import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Target, ClipboardCheck, TrendingUp, Shield, Users, Briefcase } from 'lucide-react';
import { services } from '../data/mock';
import ParallaxImage from '../components/ParallaxImage';
import ScrollFadeIn from '../components/ScrollFadeIn';
import StaggeredList from '../components/StaggeredList';

const ServicesPage = () => {
  const serviceIcons = [Target, ClipboardCheck, TrendingUp, Shield, Users, Briefcase];

  return (
    <div className="min-h-screen pt-32 pb-24">
      {/* Page Header */}
      <section className="px-8 mb-20">
        <div className="max-w-7xl mx-auto text-center">
          <div className="text-sm text-gray-500 uppercase tracking-widest mb-4 font-semibold">
            What We Do
          </div>
          <h1 className="text-6xl md:text-7xl font-bold mb-6 tracking-tight text-white">
            Services
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Comprehensive project leadership and advisory capabilities for complex infrastructure and commercial projects
          </p>
        </div>
      </section>

      {/* Services Grid with Staggered Animation */}
      <section className="px-8">
        <div className="max-w-7xl mx-auto">
          <StaggeredList
            items={services}
            renderItem={(service, index) => {
              const IconComponent = serviceIcons[index];
              return (
                <Card
                  className="bg-navy-card border-navy-border hover-lift-enhanced group mb-8"
                >
                  <CardContent className="p-10 h-full flex flex-col">
                    <div className="w-16 h-16 bg-white bg-opacity-5 rounded-sm flex items-center justify-center mb-8 group-hover:bg-opacity-10 group-hover:scale-110 transition-all duration-300">
                      <IconComponent className="w-8 h-8 text-white" strokeWidth={1.5} />
                    </div>
                    
                    <h3 className="text-2xl font-bold mb-4 leading-tight text-white group-hover:text-gray-100 transition-colors">
                      {service.title}
                    </h3>
                    
                    <p className="text-gray-400 leading-relaxed mb-6 group-hover:text-gray-300 transition-colors">
                      {service.description}
                    </p>
                    
                    <div className="mt-auto pt-6 border-t border-white border-opacity-10">
                      <p className="text-sm text-gray-500 leading-relaxed group-hover:text-gray-400 transition-colors">
                        {service.details}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              );
            }}
          />
        </div>
      </section>

      {/* Parallax Hero Image - Construction Excellence */}
      <section className="px-8 mt-32">
        <div className="max-w-7xl mx-auto">
          <ScrollFadeIn direction="up" delay={0.2}>
            <ParallaxImage
              src="https://images.unsplash.com/photo-1759318965270-0549e993a3b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxpbmZyYXN0cnVjdHVyZSUyMGNvbnN0cnVjdGlvbiUyMHByb2plY3QlMjBhZXJpYWx8ZW58MHx8fHwxNzczMDQzMzk4fDA&ixlib=rb-4.1.0&q=85"
              alt="Infrastructure construction project"
              className="h-[500px] rounded-sm"
              speed={0.3}
            />
          </ScrollFadeIn>
          <ScrollFadeIn direction="up" delay={0.4}>
            <div className="text-center mt-12">
              <h2 className="text-3xl font-bold text-white mb-4">
                Building Australia's Future
              </h2>
              <p className="text-lg text-gray-400 max-w-2xl mx-auto">
                Expert project leadership across infrastructure, commercial, and telecommunications sectors
              </p>
            </div>
          </ScrollFadeIn>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
